/* Ported from panel.davakhoone.com (TipTap 3 / Vue 3) to TipTap 2 / Vue 2 for sakhtineo. */
function escapeHtml(text = '') {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function blockTextToHtml(text = '') {
  return String(text || '')
}

function listItemsToHtml(items = [], ordered = false) {
  const tag = ordered ? 'ol' : 'ul'
  const inner = (items || [])
    .map((item) => {
      const value = typeof item === 'string' ? item : item?.content || item?.text || ''
      return `<li>${blockTextToHtml(value)}</li>`
    })
    .join('')
  return inner ? `<${tag}>${inner}</${tag}>` : ''
}

function tableToHtml(data = {}) {
  const content = Array.isArray(data.content) ? data.content : []
  if (!content.length) return ''

  const rows = content
    .map((row) => {
      const cells = (Array.isArray(row) ? row : [])
        .map((cell) => `<td>${blockTextToHtml(cell)}</td>`)
        .join('')
      return `<tr>${cells}</tr>`
    })
    .join('')

  return `<table><tbody>${rows}</tbody></table>`
}

function parseWithEdjsParser(data) {
  if (typeof window === 'undefined' || typeof window.edjsParser !== 'function') return null
  try {
    const parser = new window.edjsParser()
    if (typeof parser.parse !== 'function') return null
    const html = parser.parse(data)
    return typeof html === 'string' ? html : null
  } catch (_) {
    return null
  }
}

export function editorJsBlocksToHtml(data) {
  if (!data?.blocks?.length) return ''

  const parsedHtml = parseWithEdjsParser(data)
  if (parsedHtml != null && String(parsedHtml).trim() !== '') {
    return parsedHtml
  }

  return data.blocks
    .map((block) => {
      const type = block?.type
      const blockData = block?.data || {}

      switch (type) {
        case 'header': {
          const level = Math.min(Math.max(Number(blockData.level) || 2, 1), 6)
          return `<h${level}>${blockTextToHtml(blockData.text)}</h${level}>`
        }
        case 'paragraph':
          return `<p>${blockTextToHtml(blockData.text)}</p>`
        case 'list':
          return listItemsToHtml(blockData.items, blockData.style === 'ordered')
        case 'image': {
          const url = blockData.file?.url || blockData.url || ''
          if (!url) return ''
          const caption = blockData.caption ? `<figcaption>${escapeHtml(blockData.caption)}</figcaption>` : ''
          return `<figure><img src="${escapeHtml(url)}" alt="${escapeHtml(blockData.caption || '')}" />${caption}</figure>`
        }
        case 'table':
          return tableToHtml(blockData)
        case 'raw':
          return blockData.html || ''
        case 'quote':
          return `<blockquote><p>${blockTextToHtml(blockData.text)}</p></blockquote>`
        case 'code':
          return `<pre><code>${escapeHtml(blockData.code || '')}</code></pre>`
        case 'delimiter':
          return '<hr>'
        default:
          if (blockData.text) return `<p>${blockTextToHtml(blockData.text)}</p>`
          if (blockData.html) return blockData.html
          return ''
      }
    })
    .filter(Boolean)
    .join('')
}

export function isEditorJsContent(content) {
  return !!(content && typeof content === 'object' && Array.isArray(content.blocks))
}

export function isHtmlEditorContent(content) {
  return !!(content && typeof content === 'object' && content.format === 'html')
}

/** باز کردن لایهٔ JSON تودرتو (دادهٔ قدیمی EditorJS گاهی دو بار stringify شده) */
export function unwrapEditorPayload(raw) {
  let value = raw
  for (let i = 0; i < 4; i += 1) {
    if (typeof value !== 'string') break
    const trimmed = value.trim()
    if (!trimmed) return ''
    if (trimmed.startsWith('<')) return trimmed
    try {
      value = JSON.parse(trimmed)
    } catch {
      return trimmed
    }
  }
  return value
}

export function resolveEditorInitialContent(firstContent, contentHtml = '') {
  const html = String(contentHtml || '').trim()
  if (html) return html

  if (firstContent == null || firstContent === '') return ''

  let content = unwrapEditorPayload(firstContent)

  if (typeof content === 'string') {
    const trimmed = content.trim()
    if (!trimmed) return ''
    if (trimmed.startsWith('<')) return trimmed
    return `<p>${escapeHtml(trimmed)}</p>`
  }

  if (isHtmlEditorContent(content)) {
    return String(content.html || '')
  }

  if (isEditorJsContent(content)) {
    return editorJsBlocksToHtml(content)
  }

  if (content && typeof content.html === 'string') {
    return content.html
  }

  return ''
}

export function buildEditorContentPayload(html = '') {
  return {
    format: 'html',
    html: html || '',
    time: Date.now()
  }
}

export function stringifyEditorStorageContent(content, htmlFallback = '') {
  if (isHtmlEditorContent(content)) {
    return content.html || htmlFallback || ''
  }

  if (typeof content === 'string') {
    const trimmed = content.trim()
    if (!trimmed) return htmlFallback || ''
    if (trimmed.startsWith('<')) return trimmed
    try {
      const parsed = JSON.parse(trimmed)
      if (isHtmlEditorContent(parsed)) return parsed.html || htmlFallback || ''
      if (isEditorJsContent(parsed)) return trimmed
    } catch {
      return trimmed
    }
    return trimmed
  }

  if (isEditorJsContent(content)) {
    return JSON.stringify(content)
  }

  if (htmlFallback) return htmlFallback
  return ''
}
